import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

interface BookingItem {
  Name: string;
  Value: number | null;
}

interface BookingData {
  items: BookingItem[];
}

interface FacilitesBookingDataProps {
  data: BookingData;
}

export const FacilitesBookingData = ({ data }: FacilitesBookingDataProps) => {
  // Safely map data to chart format
  const colors = ['#FF2A00', '#35B1E8'];
  const pieData =
    data?.items?.map((item, index) => ({
      name: item?.Name || 'Unknown',
      y: item?.Value ?? 0, // fallback to 0 if Value is null
      color: colors[index % colors.length], // Apply color by index
    })) || [];

  const options: Highcharts.Options = {
    chart: {
      type: 'pie',
    },
    title: {
      text: 'Fixed booking',
      style: {
        fontSize: '13px',
      },
    },
    tooltip: {
      pointFormat: '<b>{point.name}</b>: {point.y}',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        showInLegend: true,
        dataLabels: {
          enabled: true,
          format: '{point.name}: {point.y}', // Show name and value
          style: {
            fontSize: '11px', // ✅ Data label font size
          },
        },
      },
    },
    legend: {
      itemStyle: {
        fontSize: '0.9rem', // ✅ Legend font size
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Bookings',
        colorByPoint: true,
        type: 'pie',
        data: pieData,
      } as Highcharts.SeriesPieOptions,
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
